import React, { useMemo } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import {
    SnippetDetailContainerProps,
    SnippetDetailViewProps,
} from './snippetDetailProps';
import { ReportingContainerBaseConfig } from '../../../base';
import { SnippetDetailController } from './snippetDetailInterface';
import { SnippetDetailLoader } from './snippetDetailInterface';
import { SnippetEditFormValues } from './snippetDetailModel';
import { useForm } from 'react-hook-form';

export function createSnippetDetailContainer(
    config: ReportingContainerBaseConfig,
    loader: SnippetDetailLoader,
    controller: SnippetDetailController
): React.FC<SnippetDetailContainerProps> {
    const {
        context: { useContext },
        repository: { research: repository },
    } = config;

    return ({ as: View, ...containerProps }) => {
        const context = useContext();

        const mutation = {
            snippet: {
                update: repository.snippet.useUpdate(context),
            },
        };

        const data = loader.useLoad(context, {
            snippet: containerProps.snippet,
        });

        const form = useForm<SnippetEditFormValues>({
            defaultValues: useMemo(
                () => ({
                    content: data.snippet.content,
                }),
                [data.snippet]
            ),
        });
        const values = form.watch();
        const props = controller.useProps(context, data, {
            form: {
                id: 'snippet-edit',
                form: form,
                async onSubmit(payload) {
                    console.log('saving snippet', payload);
                    const response = await mutation.snippet.update.mutateAsync({
                        snippetId: containerProps.snippet.id,
                        payload: {
                            content: payload.content,
                        },
                    });
                    console.log('snippet response', response);
                    containerProps.onCancel();
                },
                onSubmitError(error) {
                    console.error('snippet error', error);
                },
            },
            field: {
                content: {
                    value: values.content,
                    onChange(value) {
                        form.setValue('content', value);
                    },
                },
            },
            onCancel: containerProps.onCancel,
        });
        return <View {...props} />;
    };
}
